<div class="coupon-layout google-coupon tiktok-layout fixed-header">
  <app-header></app-header>
  <div class="main-content">
    <div class="adcore-logo"><a href="https://www.adcore.com" target="_blank"><i></i></a></div>
    <div class="tiktok-tag" aria-hidden="true">
      <img src="/assets/images/tiktok-partner-badge.png" alt="TikTok">
    </div>
    <div class="content">
        <span>Get <span class="sign bold">$</span><span class="bold">10,000</span> TikTok Ads {{ currentYear }}</span>&nbsp;
        <span>coupon in two easy steps</span>
    </div>
    <div class="google-eligible-btn"><button (click)="goToEligibleLink('tiktok')">For eligible accounts only</button></div>
    <div class="link-acc">
      <app-link-steps [step1Text]="'Link your TikTok Ads account'" [step2Text]="'Redeem your TikTok coupon'" [stepMiddleText]="'Checked'" [showMiddleStep]="true" [accountLinked]="true" [isMiddleChaked]="true"></app-link-steps>
      <div class="buttons">
        <div>
          <p-button styleClass="link-btn" label="Redeem your coupons" (onClick)="RedeemCoupon()" [disabled]="loading"></p-button>
          <div class="loader-box green" *ngIf="loading">
            <div class="loader">
              <div></div>
            </div>
          </div>
        </div>
        <div class="text">Connect your TikTok Ads account to redeem your coupon.</div>
      </div>
    </div>
    <!-- <app-metrics [merticData]="metricData"></app-metrics> -->
    <app-video-player videoPath="https://www.youtube.com/embed/ApyYbtYY560?autoplay=1&mute=1&loop=1&playlist=ApyYbtYY560&controls=1&playsinline=1&rel=0" [type]="'tiktok'"></app-video-player>
    <app-powered [lang]="'en'" [type]="'tiktok'"></app-powered>
    <app-questions [listItemsType]="'tiktok'" [title]="'Q&A'" [selectedAccordinAIndex]="openTabIndex" (changeSelectedTabIndex)="changeSelectedTabIndex($event)"></app-questions>
    <app-footer [lang]="'en'"></app-footer>
  </div>
</div>
<p-toast key="msgTemplate" position="center">
  <ng-template let-message pTemplate="message">
    <app-msg-template [message]="message" (confirm)="got_it()">
      <div><p>{{message.detail}}</p></div>
    </app-msg-template>
  </ng-template>
</p-toast>
